import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Grid1: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--grid', 'svg-icon--grid--1')}
    data-icon={icon}
    viewBox="0 0 9 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g className={s.gridFill} fillRule="evenodd">
      <path d="M0 0h9v8H0zM0 9h9v8H0z" />
    </g>
  </svg>
);

export default Grid1;
